import { render } from "./layout3.vue?vue&type=template&id=2ac94292&scoped=true"
import script from "./layout3.vue?vue&type=script&lang=js"
export * from "./layout3.vue?vue&type=script&lang=js"

import "./layout3.vue?vue&type=style&index=0&id=2ac94292&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ac94292"]])

export default __exports__